import React, { forwardRef } from "react"
import { Image } from "./primitives"

const FastImage = Object.assign(
  forwardRef<HTMLImageElement, React.ComponentProps<typeof Image>>(function FastImage(props, ref) {
    return <Image ref={ref} {...props} />
  }),
  {
    resizeMode: {
      contain: "contain",
      cover: "cover",
      stretch: "stretch",
      center: "center",
    },
    priority: {
      low: "low",
      normal: "normal",
      high: "high",
    },
    cacheControl: {
      immutable: "immutable",
      web: "web",
      cacheOnly: "cacheOnly",
    },
    clearMemoryCache: async () => {},
    clearDiskCache: async () => {},
    preload: async () => {},
  },
)

export default FastImage
